module.exports = __webpack_public_path__ + "static/img/goal-04.0a749c4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sustainable/community/goal-04.png
// module id = 03w5
// module chunks = 2